import { useCallback, useMemo, useState } from "react"

import { useCitation } from "../hooks/use-citation"

type CitationHoverMiniViewerProps = {
  documentUrl: string
  quoteSnippet: string
  chunkSnippet: string
  enabled: boolean
  /** When docx preview is slow, enables heavy preview gating (same as full citation viewer). */
  onSlowRender?: () => void
}

export function CitationHoverMiniViewer({
  documentUrl,
  quoteSnippet,
  chunkSnippet,
  enabled,
  onSlowRender,
}: CitationHoverMiniViewerProps) {
  const { renderComponent } = useCitation()
  const [scrollContainer, setScrollContainer] = useState<HTMLDivElement | null>(null)
  const setScrollContainerRef = useCallback((node: HTMLDivElement | null) => {
    setScrollContainer(node)
  }, [])

  const content = useMemo(() => {
    if (!enabled) {
      return null
    }

    return renderComponent(documentUrl, {
      quoteSnippet: quoteSnippet || null,
      chunkSnippet: chunkSnippet || null,
      highlightScrollContainer: scrollContainer,
      onSlowRender,
    })
  }, [
    chunkSnippet,
    documentUrl,
    enabled,
    onSlowRender,
    quoteSnippet,
    renderComponent,
    scrollContainer,
  ])

  if (!content) {
    return null
  }

  return (
    <div
      ref={setScrollContainerRef}
      className="bg-background/80 max-h-[300px] overflow-auto rounded-md border"
    >
      {content}
    </div>
  )
}
